import React from "react";
import { Box, Typography } from "@mui/material";
import ReactECharts from "echarts-for-react";
import LoaderComponent from "components/Loader";

interface SegmentedBarChartProps {
  title: any;
  isLoading?: boolean;
  data: {
    technology: string;
    values: { label: string; value: number }[];
  }[];
  options: any;
}

const SegmentedBarChart: React.FC<SegmentedBarChartProps> = ({ title, isLoading, data, options }) => {
  return (
    <Box sx={{ borderRadius: '5px', backgroundColor: '#003771' }} p={2}>
      <Box sx={{ backgroundColor: '#003771' }}>
        <Typography variant="widgetTitle" sx={{ marginBottom: 2 }}>
          {title}
        </Typography>
        <Box sx={{ width: "100%", height: 350 }}>
        {!isLoading ? (
          <ReactECharts option={options} style={{ width: "100%", height: "100%" }} />
        ) : (
          <LoaderComponent pt={20}/>
        )}
        </Box>
      </Box>
    </Box>
  );
};

export default SegmentedBarChart;
